/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Heavy_Air_GridInputs */

const bn_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভারী এয়ার গ্রিড`)
};

const de_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schweres Luftgitter`)
};

const el_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy Air Grid`)
};

const en_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy Air Grid`)
};

const es_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejilla de aire pesado`)
};

const fr_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grille aérienne dense`)
};

const hi_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भारी वायु ग्रिड`)
};

const hu_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy Air Grid`)
};

const id_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaringan Udara Berat`)
};

const it_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griglia d'aria pesante`)
};

const ja_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘビーエアグリッド`)
};

const ko_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤비 에어 그리드`)
};

const nl_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwaar luchtrooster`)
};

const pl_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciężka siatka powietrzna`)
};

const pt_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade de Ar Pesado`)
};

const ru_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тяжелая воздушная решетка`)
};

const sv_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy Air Grid`)
};

const tr_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağır Hava Izgarası`)
};

const uk_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy Air Grid`)
};

const vi_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưới không khí nặng`)
};

const zh_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重型空气网格`)
};

const zh_hant_cipher_heavy_air_grid = /** @type {(inputs: Cipher_Heavy_Air_GridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重型空氣網格`)
};

/**
* | output |
* | --- |
* | "Heavy Air Grid" |
*
* @param {Cipher_Heavy_Air_GridInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_heavy_air_grid = /** @type {((inputs?: Cipher_Heavy_Air_GridInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Heavy_Air_GridInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_heavy_air_grid(inputs)
	if (locale === "de") return de_cipher_heavy_air_grid(inputs)
	if (locale === "el") return el_cipher_heavy_air_grid(inputs)
	if (locale === "en") return en_cipher_heavy_air_grid(inputs)
	if (locale === "es") return es_cipher_heavy_air_grid(inputs)
	if (locale === "fr") return fr_cipher_heavy_air_grid(inputs)
	if (locale === "hi") return hi_cipher_heavy_air_grid(inputs)
	if (locale === "hu") return hu_cipher_heavy_air_grid(inputs)
	if (locale === "id") return id_cipher_heavy_air_grid(inputs)
	if (locale === "it") return it_cipher_heavy_air_grid(inputs)
	if (locale === "ja") return ja_cipher_heavy_air_grid(inputs)
	if (locale === "ko") return ko_cipher_heavy_air_grid(inputs)
	if (locale === "nl") return nl_cipher_heavy_air_grid(inputs)
	if (locale === "pl") return pl_cipher_heavy_air_grid(inputs)
	if (locale === "pt") return pt_cipher_heavy_air_grid(inputs)
	if (locale === "ru") return ru_cipher_heavy_air_grid(inputs)
	if (locale === "sv") return sv_cipher_heavy_air_grid(inputs)
	if (locale === "tr") return tr_cipher_heavy_air_grid(inputs)
	if (locale === "uk") return uk_cipher_heavy_air_grid(inputs)
	if (locale === "vi") return vi_cipher_heavy_air_grid(inputs)
	if (locale === "zh") return zh_cipher_heavy_air_grid(inputs)
	return zh_hant_cipher_heavy_air_grid(inputs)
});